import { useForm } from "react-hook-form";
import Filter from "./Filter"
import { Box, TextField } from "@mui/material";
import { IMaskInput } from "react-imask";
export const FilterUsers = ({ onFilter }) => {

    const defaultValues = {
        id: "",
        name: "",
        email: "",
        document: "",
        phone: "",
    }

    const methods = useForm({ defaultValues });

    return (
        <Filter onFilter={methods.handleSubmit(onFilter)} onClear={() => methods.reset(defaultValues)}>
            <Box display='flex' flexDirection='column' className='gap-1'>
                <TextField
                    id="id"
                    label="ID"
                    variant="outlined"
                    name="id"
                    {...methods.register("id")}
                />
                
                <TextField
                    id="name"
                    label="Nome"
                    variant="outlined"
                    name="name"
                    {...methods.register("name")}
                />

               <TextField
                    id="email"
                    label="Email"
                    variant="outlined"
                    name="email"
                    {...methods.register("email")}
                />

                <TextField
                    id="document"
                    label="Documento"
                    variant="outlined"
                    name="document"
                    {...methods.register("document")}
                    InputProps={{
                        inputComponent: IMaskInput,
                    }}
                    inputProps={{
                        mask: "000.000.000-00"
                    }}
                />

                <TextField
                    id="phone"
                    label="Telefone"
                    variant="outlined"
                    name="phone"
                    {...methods.register("phone")}
                    InputProps={{
                        inputComponent: IMaskInput,
                    }}
                    inputProps={{
                        mask: "(00)00000-0000"
                    }}
                />
 
            </Box>
        </Filter>

    )
}